module.exports = __webpack_public_path__ + "static/media/nav_cp_bg.7f48884b.png";